<template>
  <div class="pages flex flex-direction align-center justify-start" style="margin: 0 auto;">
    <div class="tabs-fixed">
      <div class="tabs flex align-start justify-between" :class="'tab-'+tabCurrent">
        <div class="tabs-item" @click="setTabCurrent(1)"></div>
        <div class="tabs-item" @click="setTabCurrent(2)"></div>
      </div>
    </div>
    <div class="map-image-view flex flex-direction align-center justify-start" v-if="tabCurrent==1">
      <img class="map-image" :src="'https://assets.pfotoo.com/images/version-map/%E4%B8%AA%E4%BA%BA%E7%89%8820241108/%E7%BC%96%E7%BB%84%2012%E5%A4%87%E4%BB%BD%205.png'+cacheVer"/>
      <img class="map-image" :src="'https://assets.pfotoo.com/images/version-map/%E4%B8%AA%E4%BA%BA%E7%89%8820241108/%E7%BC%96%E7%BB%84%2012%E5%A4%87%E4%BB%BD%206.png'+cacheVer"/>
      <img class="map-image" :src="'https://assets.pfotoo.com/images/version-map/%E4%B8%AA%E4%BA%BA%E7%89%8820241108/%E7%BC%96%E7%BB%84%2012%E5%A4%87%E4%BB%BD%207.png'+cacheVer"/>
      <img class="map-image" :src="'https://assets.pfotoo.com/images/version-map/%E4%B8%AA%E4%BA%BA%E7%89%8820241108/%E7%BC%96%E7%BB%84%2012%E5%A4%87%E4%BB%BD%208.png'+cacheVer"/>
      <img class="map-image" :src="'https://assets.pfotoo.com/images/version-map/%E4%B8%AA%E4%BA%BA%E7%89%8820241108/%E7%BC%96%E7%BB%84%2012%E5%A4%87%E4%BB%BD%209.png'+cacheVer"/>
      <img class="map-image" :src="'https://assets.pfotoo.com/images/version-map/%E4%B8%AA%E4%BA%BA%E7%89%8820241108/%E7%BC%96%E7%BB%84%2012%E5%A4%87%E4%BB%BD%2010.png'+cacheVer"/>
      <img class="map-image" :src="'https://assets.pfotoo.com/images/version-map/%E4%B8%AA%E4%BA%BA%E7%89%8820241108/%E7%BC%96%E7%BB%84%2012%E5%A4%87%E4%BB%BD%2011.png'+cacheVer"/>
      <template v-for="(pos,index) in poss[tabCurrent]">
        <div class="map-image-click" @click="showModal(index)" :style="{top:(pos.top)+'px'}">{{pos.imgName}}</div>
      </template>
    </div>
    <div class="map-image-view flex flex-direction align-center justify-start" v-if="tabCurrent==2">
      <template v-for="idx in 7">
        <img class="map-image" :src="'https://assets.pfotoo.com/images/version-map/%E4%BC%81%E4%B8%9A%E7%89%8820241108/'+idx+'.png'+cacheVer"/>
      </template>
      <template v-for="(pos,index) in poss[tabCurrent]">
        <div class="map-image-click" @click="showModal(index)" :style="{top:(pos.top)+'px'}">{{pos.imgName}}</div>
      </template>
    </div>
    <div class="showModalDialog flex align-end" v-if="showModalDialog" @click="hideModal">
      <div class="showModalDialog-view" @click.stop>
        <div class="header flex align-center justify-center" @click="hideModal">
          <div class="close"></div>
        </div>
        <div class="showModalDialog-content">
          <img :src="'https://assets.pfotoo.com/images/version-map/helps/'+imgName+'.jpg'+cacheVer"/>
        </div>
      </div>
    </div>
    <serviceFixed></serviceFixed>
  </div>
</template>

<script>
  let fix1=190,fix2=60,fix3=150,fix4=fix3+300,fix5=fix4+300
  let qyfix1=550,qyfix2=qyfix1+60,qyfix3=qyfix2+240,qyfix4=qyfix3+240
  window.POSITION=[
    '',
    [{"top":5,"imgName":"去除活动内部广告"},{"top":65,"imgName":"去除封面广告"},
      {"top":150,"imgName":"承载人数"},
      //团队协作
      {"top":145+90,"imgName":"活动管理员"},{"top":205+90,"imgName":"活动协作员"},
      //配套云资源
      {"top":295+90,"imgName":"云存储空间"},{"top":355+90,"imgName":"存储有效期"},{"top":415+90,"imgName":"下载额度"},{"top":475+90,"imgName":"云流量"},
      //单次上传规则
      {"top":560+90,"imgName":"照片单次上传规则"},{"top":620+90,"imgName":"照片质量"},{"top":680+90,"imgName":"视频单次上传规则"},{"top":740+90,"imgName":"视频质量"},{"top":800+90,"imgName":"音频单次上传规则"},{"top":860+90,"imgName":"文档单次上传规则"},{"top":920+90,"imgName":"文字单次上传规则"},{"top":920+fix3,"imgName":"倍速播放"},
      //评委评选
      {"top":1005+fix3,"imgName":"评委人数"},{"top":1065+fix3,"imgName":"其他信息（选项、建议…）"},{"top":1125+fix3,"imgName":"多语言（英语&法语）"},
      //大众投票
      {"top":1210+fix3,"imgName":"反刷票"},{"top":1270+fix3,"imgName":"指定作品参与投票"},{"top":1330+fix3,"imgName":"限定投票地区"},{"top":1390+fix3,"imgName":"向参与者隐藏票数"},{"top":1450+fix3,"imgName":"PK投票"},
      //活动设置
      {"top":1535+fix3,"imgName":"活动封面数量"},{"top":1595+fix3,"imgName":"活动视频封面"},{"top":1655+fix3,"imgName":"活动背景音乐"},{"top":1715+fix3,"imgName":"限制每人每天上传次数"},{"top":1775+fix3,"imgName":"符合名单后上传"},{"top":1835+fix3,"imgName":"限定上传地区"},{"top":1895+fix3,"imgName":"匿名"},{"top":1955+fix3,"imgName":"组别赛道"},{"top":2015+fix3,"imgName":"征稿单元"},{"top":2075+fix3,"imgName":"活动介绍图文结合"},{"top":2135+fix3,"imgName":"作品明水印"},{"top":2195+fix3,"imgName":"作品双列瀑布流"},{"top":2255+fix3,"imgName":"作品大图展示"},{"top":2315+fix3,"imgName":"主题颜色自定义：红色+蓝色"},
      //活动范围设置
      {"top":2100+fix4,"imgName":"微信群活动"},{"top":2160+fix4,"imgName":"设置活动密码"},{"top":2220+fix4,"imgName":"仅限公众号粉丝参加"},{"top":2280+fix4,"imgName":"指定用户参加活动"},{"top":2340+fix4,"imgName":"投稿内容仅组织者可见"},{"top":2400+fix4,"imgName":"禁止参与者分享"},{"top":2460+fix4,"imgName":"禁止参与者分享"},
      //营销功能与品牌自定义
      {"top":2485+60+fix4,"imgName":"设置活动奖品"},{"top":2545+60+fix4,"imgName":"填写项卡片展示设置"},{"top":2605+60+fix4,"imgName":"自定义按钮名称"},{"top":2665+60+fix4,"imgName":"品牌认证"}, {"top":2725+60+fix4,"imgName":"平台推广"},{"top":2785+60+fix4,"imgName":"自定义活动分享文案/图片"},{"top":2845+60+fix4,"imgName":"自定义品牌二维码LOGO"},{"top":2905+60+fix4,"imgName":"禁止搜索活动"},{"top":2965+60+fix4,"imgName":"参与者只能看当前活动"},
      //统计与导出
      {"top":2750+fix2+fix5,"imgName":"数据查看与导出"},{"top":2810+fix2+fix5,"imgName":"一键下载"},{"top":2870+fix2+fix5,"imgName":"下载文件指定命名"},
      //公布结果
      {"top":2950+fix2+fix5,"imgName":"公布结果名单"},{"top":3010+fix2+fix5,"imgName":"在线查询结果"},{"top":3070+fix2+fix5,"imgName":"群发微信服务通知"}],
    [{"top":30,"imgName":"去除封面广告"},{"top":90,"imgName":"多语言（英语&法语）"},{"top":150,"imgName":"PK投票"},{"top":210,"imgName":"活动视频封面"},{"top":270,"imgName":"禁止参与者分享"},{"top":330,"imgName":"线上培训支持"},{"top":390,"imgName":"参与者只能看当前活动"},{"top":450,"imgName":"Fotoo首页推广"},{"top":510,"imgName":"活动介绍图文结合"},{"top":570,"imgName":"自定义活动分享文案图片"},{"top":630,"imgName":"封面品牌广告宣传（开屏广告）"},{"top":690,"imgName":"作品大图展示"},{"top":750,"imgName":"自定义品牌二维码LOGO"},{"top":810,"imgName":"H5"},
      {"top":345+qyfix1,"imgName":"承载人数"},
      {"top":430+qyfix1,"imgName":"活动管理员"},{"top":490+qyfix1,"imgName":"活动协作员"},

      {"top":575+qyfix1,"imgName":"云存储空间"},{"top":635+qyfix1,"imgName":"存储有效期"},{"top":695+qyfix1,"imgName":"下载额度"},{"top":755+qyfix1,"imgName":"云流量"},
      {"top":840+qyfix1,"imgName":"照片单次上传规则"},{"top":900+qyfix1,"imgName":"照片质量"},{"top":960+qyfix1,"imgName":"视频单次上传规则"},{"top":1020+qyfix1,"imgName":"视频质量"},{"top":1080+qyfix1,"imgName":"音频单次上传规则"},{"top":1140+qyfix1,"imgName":"文档单次上传规则"},{"top":1200+qyfix1,"imgName":"文字单次上传规则"},{"top":1260+qyfix1,"imgName":"倍速播放"},
      {"top":1285+qyfix2,"imgName":"评委人数"},{"top":1345+qyfix2,"imgName":"其他信息（选项、建议…）"},
      {"top":1430+qyfix2,"imgName":"反刷票"},{"top":1490+qyfix2,"imgName":"指定作品参与投票"},{"top":1550+qyfix2,"imgName":"限定投票地区"},{"top":1610+qyfix2,"imgName":"向参与者隐藏票数"},
      {"top":1695+qyfix2,"imgName":"活动封面数量"},{"top":1755+qyfix2,"imgName":"活动背景音乐"},{"top":1815+qyfix2,"imgName":"限制每人每天上传次数"},{"top":1875+qyfix2,"imgName":"符合名单后上传"},{"top":1935+qyfix2,"imgName":"限定上传地区"},{"top":1995+qyfix2,"imgName":"匿名"},{"top":2055+qyfix2,"imgName":"组别赛道"},{"top":2115+qyfix2,"imgName":"征稿单元"},
      {"top":2175+qyfix2,"imgName":"作品明水印"},{"top":2235+qyfix2,"imgName":"作品大图展示"},{"top":2295+qyfix2,"imgName":"作品双列瀑布流"},{"top":2355+qyfix2,"imgName":"主题颜色自定义：红色+蓝色"},
      {"top":2200+qyfix3,"imgName":"微信群活动"},{"top":2260+qyfix3,"imgName":"设置活动密码"},{"top":2320+qyfix3,"imgName":"仅限公众号粉丝参加"},{"top":2380+qyfix3,"imgName":"指定用户参加活动"},{"top":2440+qyfix3,"imgName":"投稿内容仅组织者可见"},
      {"top":2520+qyfix3,"imgName":"设置活动奖品"},{"top":2580+qyfix3,"imgName":"填写项卡片展示设置"}
      ,{"top":2640+qyfix3,"imgName":"品牌认证"}
      ,{"top":2700+qyfix3,"imgName":"自定义按钮名称"},
      {"top":2760+qyfix3,"imgName":"禁止搜索活动"},{"top":2820+qyfix3,"imgName":"填写项卡片展示设置"},{"top":2880+qyfix3,"imgName":"自定义品牌二维码LOGO"},{"top":2940+qyfix3,"imgName":"主办方主页多个活动"},
      {"top":2730+60+qyfix4,"imgName":"数据查看与导出"},{"top":2790+60+qyfix4,"imgName":"一键下载"},{"top":2850+60+qyfix4,"imgName":"下载文件指定命名"},
      {"top":2935+60+qyfix4,"imgName":"公布结果名单"},{"top":2995+60+qyfix4,"imgName":"在线查询结果"},{"top":3055+60+qyfix4,"imgName":"群发微信服务通知"}],
  ]
  import serviceFixed from '../components/service-fixed.vue'
  export default {
    components: {
      serviceFixed,
    },
    data () {
      return {
        tabCurrent:'',
        poss:POSITION,
        showModalDialog:false,
        imgName:'',
        cacheVer:'?19',
      }
    },
    methods: {
      setTabCurrent(val){
        this.tabCurrent=val
      },
      showModal(idx){
        this.showModalDialog=true
        this.imgName=this.poss[this.tabCurrent][idx].imgName
      },
      hideModal(){
        this.showModalDialog=false
      }
    },
    created(){
      this.tabCurrent=this.$route.params.tabCurrent
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  div.pages{
    background-color: #F1DAB9;
    width: 375px;
    padding: 120px 0 60px;
  }
  .tabs-fixed{
    position: fixed;
    z-index: 1;
    top:0px;
    background-color: #F1DAB9;
    width: 375px;
    height: 120px;
    padding-top: 10px;
    padding-left: 5px;
  }
  .tabs{
    width: 365px;
    height: 110px;
    position: relative;
    background-size: 100% 100%;
  }
  .tab-1{
    background-image: url("https://assets.pfotoo.com/images/version-map/%E4%B8%AA%E4%BA%BA%E7%89%88/%E7%BC%96%E7%BB%84%2016@3x.png");
  }
  .tab-2{
    background-image: url("https://assets.pfotoo.com/images/version-map/%E4%BC%81%E4%B8%9A%E7%89%88%E5%85%A8%E9%83%A8/%E7%BC%96%E7%BB%84%2016@3x.png?1");
  }
  .tabs-item{
    width: 50%;
    height: 40px;
  }
  .map-image{
    width: 366px;
  }
  .map-image-view{
    margin-top: 10px;
    position: relative;
  }
  .map-image-click{
    position: absolute;
    height: 50px;
    width: 100%;
    background-color: rgba(255,0,0,0.0);
    text-indent: -1200px;
    color: #fefefe;
    font-size: 16px;
    font-weight: bold;
    line-height: 50px;
  }
  .showModalDialog{
    position: fixed;
    bottom: 0;
    background-color: rgba(0,0,0,0.6);
    z-index: 1;
    width: 100%;
    height: 100%;
  }
  .showModalDialog-view{
    width: 375px;
    padding: 0 20px 40px;
    box-sizing: border-box;
    background: #FFFFFF;
    border-radius: 10px 10px 0 0;
    margin: 0 auto;
  }
  .showModalDialog-content{
    height: 60vh;
    width: 100%;
    overflow-y: auto;
  }
  .showModalDialog-content img{width: 100%;}
  .header{
    height: 60px;
    width: 100%;
  }
  .close{
    width: 40px;
    height: 20px;
    background-size: 100% 100%;
    background-image: url("https://assets.pfotoo.com/images/version-map/helps/%E7%BC%96%E7%BB%84%206@3x.png");
  }
</style>



// WEBPACK FOOTER //
// src/pages/version-map.vue